import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import AInput from '../../../common/formFeilds/customInput/AInput';
import moment from 'moment';
import AButton from '../../../common/form-fields-mui/AButton';
import ADataGrid from '../../../common/data-grid/ADataGrid';
import { GridRowModes } from '@mui/x-data-grid';
import { isObjEmpty } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { failureToast } from '../../../common/utils/methods/toasterFunctions/function';
import { saveOrDeleteMsg } from '../../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { generateRandomId } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { AGridColDef } from '../../../common/data-grid/ADataGridColDef';
import { editCellContainerStyle } from '../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import AAutoComplete from '../../../common/form-fields-mui/AAutoComplete';
import { gridStyles, gridComponents } from '../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { ActionsCellComponent, StatusCellComponent} from '../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { newRow } from './common';
import ALoader from '../../../common/a-loader';
import NoRowOverlay from '../../../masters/holidayMaster/NoRowOverlay';
import HistoryPopup from './HistoryPopup';
import MultiSelectCellComponentWithSearch from '../../../common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';


const ListComponent = ({
    allActiveProcess = [],
    rolesDropdown=[],
    rows=[],
    createUpdateHandler,
    loading,
    currentPage,
    totalRecords,
    pageChangeHandler,
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    const [historyPopupOpen, setHistoryPopupOpen] = useState(null);

    const processTypeDropdown = allActiveProcess?.filter(process => !(!!(rows?.find(row => row.processTagTypeMasterId === process.value))));


    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);


    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit, fieldToFocus: "processType" },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = generateRandomId();
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: randomId,
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [

        new AGridColDef('processType', 'Process Type', false)
            .setMinWidth(110)
            .setFlex(0.7)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.processType}
                        handleChange={value => {
                            rowFormHandler(value, 'processType');
                        }}
                        items={processTypeDropdown}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('roles', 'Roles', false)
            .setMinWidth(110)
            .setFlex(0.7)
            .editable(true)
            .renderCellComponent((params) => 

                
                    <MultiSelectCellComponentWithSearch
                    title={"Roles"}
                    data={params?.value}
                    eyeIcon
                  />
                )
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.roles}
                        handleChange={value => {
                            rowFormHandler(value, 'roles');
                        }}
                        items={rolesDropdown}
                        isMulti={true}
                        isShowCount={true}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('history', 'History', false)
            .setMinWidth(80)
            .setFlex(0.4)
            .editable(true)
            .renderCellComponent(params => (
                <AButton
                variant='primary_filled'
                size='xs'
                className='no-ml-btn'
                onClick={()=>setHistoryPopupOpen(params?.row)}
                >
                  History
                </AButton>

            ))
            .renderEditCellComponent(params => (
              <AButton
              variant='primary_filled'
              size='xs'
              className='no-ml-btn'
              disabled
              onClick={()=>setHistoryPopupOpen(params?.row)}
              >
                History
              </AButton>
            )),

        new AGridColDef('updatedOn', 'Last Updated On', false)
            .setMinWidth(100)
            .setFlex(0.5)
            .editable(false)
            .renderCellComponent(params => (
                <div>{moment(params.value).format('DD-MMM-YYYY hh:mm a')}</div>
            )),

            new AGridColDef('status', 'Status', false)
            .setMinWidth(50)
            .setFlex(0.3)
            .editable(true)
            .renderCellComponent(params =>
                <StatusCellComponent value={params.value} />
            )
            .renderEditCellComponent(params => (
                <StatusCellComponent
                    value={rowForm?.status}
                    handleChange={val => rowFormHandler(val, 'status')}
                />
            )),

        new AGridColDef('actions', 'Action', false)
            .setMinWidth(90)
            .setFlex(0.4)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    params={params}
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    params={params}
                />
            )),

    ]

    return (
        <>
            {loading && <ALoader position='fixed' />}
            <ADataGrid
                removeWrapperContainer
                rowModesModel={rowModesModel}
                rows={rowData || []}
                columns={columns}
                rowId={(row) => row.id}
                hidePagination
                rowHeight={50}
                loading={false}
                rowCount={totalRecords}
                nextButtonHandler={pageChangeHandler}
                currentPage={currentPage}
                components={{
                    ...gridComponents,
                    NoRowsOverlay: () => (
                        <NoRowOverlay message={loading ? "Loading..." : null} />
                    ),
                }}
                sx={gridStyles}
                autoHeight
            // pinLastColumn
            />
            <HistoryPopup
            open={historyPopupOpen}
            setOpen={setHistoryPopupOpen}
            allActiveRoles={rolesDropdown}
            />
        </>
    );
}

export default forwardRef(ListComponent);